import React from "react";
import * as Reports from "../../../ReportComponents/reportStyles";
import { styles } from "./styles";
import { withStyles } from "@material-ui/core";
import StyledAxlMultiSelect from "../../../../components/StyledAxlMultiSelect";


export const REGION_DEFAULT = "all";

const RegionMultiSelect = ({handleOnChange,values,name,regions}) => {
    
    const handleChangeRegions = (value) => {
        const regionList = value && value.length > 0 ? value.map(r => r.value) : REGION_DEFAULT;
        handleOnChange(name,regionList);        
    }

    const regionValues = values ? regions.filter(rg => values.includes(rg.value)):undefined;
    return (
        <Reports.GroupField style={{textAlign: 'left'}}>
            <Reports.Label>{`in`}</Reports.Label>
            <StyledAxlMultiSelect
                defaultValue={regionValues && regions.filter(option => regions.indexOf(option.value) >= 0)}
                placeholderButtonLabel="all regions"
                showValues={false}
                allowAll={true}
                onChange={handleChangeRegions}
                placeholder="Search Regions…"
                options={regions}
                isSearchable={true}
            />
        </Reports.GroupField>
    )     
    
}
export default withStyles( styles )(RegionMultiSelect);
